export default class DirectiveClickOutside {
  static install(Vue, options) {

    function isServer(vNode) {
      return typeof vNode.componentInstance !== 'undefined' && vNode.componentInstance.$isServer
    }

    Vue.directive("eventoutside", {
      created() {
        if (document && document.documentElement.classList == undefined) {
          console.warn("htmlclass: DOM.classList is not available, use polyfill")
        }
      },
      bind(el, binding, vNode) {
        if (typeof binding.value !== 'function') {
          throw new Error("eventoutside: binding has to be a function")
        }

        el.__vueEventOutside = {
          handler: function(e) {
            if (!vNode.context) return
            // if the target is in dom and the element does not contain the target and the target is not the element
            if (e.target.getRootNode() == document && !el.contains(e.target) && el != e.target) {
              el.__vueEventOutside.callback(e)
            }
          },
          event: binding.arg || "click",
          callback: binding.value,
          isUnbound: false
        }
        setTimeout(() => {
          if (!el.__vueEventOutside.isUnbound) {
            !isServer(vNode) && document.addEventListener(el.__vueEventOutside.event, el.__vueEventOutside.handler)
          }
        }, 0)

      },
      unbind(el, binding, vNode) {
        el.__vueEventOutside.isUnbound = true
        !isServer(vNode) && document.removeEventListener(el.__vueEventOutside.event, el.__vueEventOutside.handler)
      }
    })
  }
}
